import { render, staticRenderFns } from "./LeverdagTable.vue?vue&type=template&id=7012bdc5&scoped=true&"
import script from "./LeverdagTable.vue?vue&type=script&lang=js&"
export * from "./LeverdagTable.vue?vue&type=script&lang=js&"
import style0 from "./LeverdagTable.vue?vue&type=style&index=0&id=7012bdc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012bdc5",
  null
  
)

export default component.exports